import React, { memo } from 'react';
import { isEmpty, isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Line } from 'react-chartjs-2';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import { useParsePreviewData } from '../hooks/useParsePreviewData.jsx';
import { useChartOptions } from '../hooks/useChartOptions.jsx';

function SensorValuesChartInner({ previewData, isLoading }) {
  const { t } = useTranslation();

  const { datasets, labels, minDate, maxDate } =
    useParsePreviewData(previewData);
  const options = useChartOptions(minDate, maxDate);

  return (
    <CollapseBlock collapsible title={t('Graf')}>
      {!isEmpty(options) &&
      !isEmpty(datasets) &&
      !isUndefined(previewData) &&
      !isLoading ? (
        <Line
          className="meteo-station-graph"
          options={options}
          data={{
            labels: labels,

            datasets: (previewData || []).map((attribute) => ({
              label: `${attribute.sensor.name} - ${attribute.label} [${attribute.attribute_unit.unit}]`,
              data: datasets[attribute.id],
              segment: {
                borderDash: (ctx) => shouldBeSegmentSkipped(ctx, [6, 6]),
              },
              // enabled connecting lines, where are no data
              // where are no data dashed line will be present instead of solid line
              spanGaps: true,
              pointRadius: 0,
            })),
          }}
        />
      ) : isLoading ? (
        <Spinner />
      ) : (
        <div className="meteo-station-no-data-banner">
          <h5>{t('Nie sú k dispozícií žiadne dáta!')}</h5>
          <p>{t('Začnite výberom atribútov a časového obdobia')}</p>
        </div>
      )}
    </CollapseBlock>
  );
}

export const SensorValuesChart = memo(SensorValuesChartInner);

function shouldBeSegmentSkipped(ctx, value) {
  return ctx.p0.parsed.y === null ? value : undefined;
}
